var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3532 8.97656L13.2563 2.70536C12.5594 1.64063 11.45 1.07143 10.325 1.07143C9.61879 1.07143 8.90316 1.29576 8.27816 1.76451C7.66253 2.22656 7.22503 2.86272 6.98128 3.56585C6.89065 1.58036 5.37502 0 3.50001 0C1.56563 0 0 1.67746 0 3.75V11.25C0 13.3225 1.56563 15 3.50001 15C5.4344 15 7.00003 13.3225 7.00003 11.25V6.25781C7.10315 6.54576 7.22815 6.83036 7.40003 7.09487L11.5 13.3661C12.1938 14.4308 13.3032 15 14.4313 15C15.1407 15 15.8532 14.7757 16.4782 14.3069C18.0938 13.0949 18.4844 10.7076 17.3532 8.97656ZM5.00002 7.5H2.00001V3.75C2.00001 2.86272 2.67189 2.14286 3.50001 2.14286C4.32814 2.14286 5.00002 2.86272 5.00002 3.75V7.5ZM11.0875 9.00335L9.03754 5.86607C8.79691 5.49777 8.70316 5.04911 8.77816 4.60714C8.85004 4.16518 9.08129 3.77679 9.42504 3.51897C9.69066 3.31808 10.0032 3.21429 10.325 3.21429C10.8407 3.21429 11.3219 3.48214 11.6157 3.93415L13.6657 7.07143L11.0875 9.00335Z",
    fill: "#B6BEC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptions);
export default __webpack_public_path__ + "static/media/prescriptions.60c91135a0a3af70eaa95ae238750e4b.svg";
export { ForwardRef as ReactComponent };